"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Initialize = _interopRequireDefault(require("./Initialize"));
var LoginStatus = /*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2["default"])(LoginStatus, _Component);
  function LoginStatus() {
    var _this;
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleReady", function _callee(api) {
      var event;
      return _regenerator["default"].async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event = _this.props.event;
              _this.setState({
                api: api
              });
              _context.next = 4;
              return _regenerator["default"].awrap(api.subscribe(event, _this.handleChange));
            case 4:
            case "end":
              return _context.stop();
          }
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function () {
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange.apply(void 0, arguments);
      }
    });
    return _this;
  }
  var _proto = LoginStatus.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    var api = this.state.api,
      event = this.props.event;
    if (api) {
      api.unsubscribe(event, this.handleChange);
    }
  };
  _proto.render = function render() {
    var children = this.props.children;
    return _react["default"].createElement(_Initialize["default"], {
      onReady: this.handleReady
    }, children);
  };
  return LoginStatus;
}(_react.Component);
exports["default"] = LoginStatus;
(0, _defineProperty2["default"])(LoginStatus, "defaultProps", {
  onChange: undefined
});
//# sourceMappingURL=Subscribe.js.map
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-facebook/lib/Subscribe.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-facebook/lib/Subscribe.js");
  }
}();